const development = process.env.NODE_ENV === 'development'

export function AmplitudeCounter (event: string, obj?: { [key: string]: any }) {
  if (development || !window.amplitude) return

  try {
    window.amplitude.getInstance().logEvent(event, obj)
  } catch (err) {
    console.error(err)
  }
}

export function AmplitudeUserProp (obj: { [key: string]: any }) {
  if (development || !window.amplitude) return
  try {
    window.amplitude.getInstance().setUserProperties(obj)
  } catch (err) {
    console.error(err)
  }
}
